import { Box } from "@mui/material";
import KpiTile from "../components/KpiTile";
import StatsGate from "../components/StatsGate";
import { Overview, TabProps } from "../types";
import { useStats } from "../useStats";

const LABELS: Array<[string, string]> = [
  ["activeUsers", "Active fans"], ["newUsers", "New fans"], ["messages", "Chat messages"],
  ["reactions", "Reactions"], ["uniqueGames", "Games with chat or reactions"], ["watchPartiesCreated", "Watch parties"],
  ["momentsCreated", "Fan clips"], ["downloadsCompleted", "Downloads"], ["reports", "Reports"],
  ["secondScreenPairings", "Second-screen pairings"],
];

export default function OverviewTab({ query, reloadKey, gameId }: TabProps) {
  const state = useStats<Overview>("/overview", query, reloadKey);
  // New fans are not scoped to a single game, so say so once a game id filters everything else.
  const suffix = gameId ? " (all games)" : "";
  return (
    <StatsGate state={state}>
      {(data) => (
        <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", lg: "repeat(5, 1fr)" } }}>
          {LABELS.map(([key, label]) => (
            <KpiTile
              key={key} label={key === "newUsers" ? `${label}${suffix}` : label}
              value={data[key]?.value ?? null} previous={data[key]?.previous}
            />
          ))}
        </Box>
      )}
    </StatsGate>
  );
}
